import React from "react";


import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer"; // keep the path you use in your project
import Herolast  from "../screen/herolast";
import Callback  from "../components/callback";






import Hero from "../screen/hero";         // adjust path if Hero.jsx lives elsewhere
import Ourservice from "../screen/ourservice";
import Homeabout from "../screen/HomeAbout";
import Transfom from "../screen/transfom";
import Type from "../screen/typesac";
import Review from "../screen/review";
import Chooseus from "../screen/ChooseUs";





const Home = () => {
  return (
    <>
    <Topbar/>
      {/* Top navigation/header */}
      <Header />

      {/* Hero section (only hero content now) */}
      <Hero />
      <Callback />

      {/* Site sections (same order as before) */}
      <Ourservice />
      <Homeabout />
      <Transfom />
      <Type />
      <Review />
      <Chooseus />
      <Herolast  />
      <Footer  />
    </>
  );
};

export default Home;
